const $ = require('jquery');
const defaults = require('lodash/defaults');
const assign = require('lodash/assign');
const throttle = require('lodash/throttle');

let slideshows = $('.js-lazyload-slick');
const defaultSettings = { slideshowSettings: {} };
const offsetLoadY = 100;
require('./slick-carousel');

function checkScroll(settings) {
  const $window = $(this);
  const totalSlideshows = slideshows.length;
  let slideshowIteratorCount = 0;

  slideshows.each(function allSlides() {
    const $slideshow = $(this);

    if ($slideshow.attr('lazyTriggered') === 'false') {
      const y = $slideshow.offset().top;
      const visibleY = $window.scrollTop() + $window.innerHeight();
      if (y < visibleY + offsetLoadY) {
        $slideshow.removeClass('js-lazyload-slick');
        $slideshow.slick(settings.slideshowSettings);
        $slideshow.attr('lazyTriggered', true);
      }
    } else {
      slideshowIteratorCount += 1;
    }
  });

  if (slideshowIteratorCount === totalSlideshows) {
    $(window).off('scroll.lazyloadSlideshow resize.lazyloadSlideshow');
  }
}


function init(userSettings) {
  const settings = assign({}, defaultSettings, userSettings);
  slideshows = $('.js-lazyload-slick').not('.slick-initialized');
  slideshows.attr('lazyTriggered', false);
  $(window).on('scroll.lazyloadSlideshow resize.lazyloadSlideshow', throttle(() => {
    checkScroll(settings);
  }, 100));

  checkScroll(settings);
}

module.exports = init;
defaults(module.exports, {});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/lazyload.js